import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Simulate form submission
    console.log('Form submitted:', formData);
    // setSubmitted(true);
    // setTimeout(() => setSubmitted(false), 5000);
    await fetch('https://alphaauditing.com/backend/mail.php', {
      body: JSON.stringify({
        title: `New Contact Form Submission from ${formData.name}`,
        name: formData.name,
        company: formData.company,
        email: formData.email,
        phone: formData.phone,
        message: formData.message
      }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(async (response) => {
      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Submission failed');
      }

      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 5000);

      setFormData({ name: '', company: '', email: '', phone: '', message: '' });
      setSubmitted(true);
    }).catch((error) => {
      console.error('Error:', error);
    });
    // setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <section id="contact" className="py-12 md:py-20 bg-slate-50 min-h-[600px] md:min-h-[700px]">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row min-h-[500px] md:min-h-[600px]">
          <div className="md:w-1/3 bg-primary p-6 md:p-10 text-white flex flex-col justify-between min-h-[250px] md:min-h-auto">
            <div>
              <h3 className="text-2xl font-bold mb-4">Consult Now</h3>
              <p className="text-slate-300 mb-8">
                Ready to streamline your financial assurance? Fill out the form and our team will get back to you within 24 hours.
              </p>
            </div>
            <div className="space-y-4">
              <p className="text-sm text-slate-400">Email us directly</p>
              <p className="font-semibold">contact@alphaauditing.com</p>
              <p className="text-sm text-slate-400 mt-4">Call us</p>
              <p className="font-semibold">+961 3 769 664</p>
            </div>
          </div>

          <div className="md:w-2/3 p-6 md:p-10 flex flex-col justify-center">
            {submitted ? (
              <div className="h-full flex flex-col items-center justify-center text-center min-h-[300px]">
                <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
                <h3 className="text-2xl font-bold text-primary mb-2">Message Sent!</h3>
                <p className="text-slate-600">Thank you for contacting Alpha. We'll be in touch shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-1 focus:ring-secondary outline-none transition-all"
                      placeholder="John Doe"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Company Name</label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-1 focus:ring-secondary outline-none transition-all"
                      placeholder="Acme Corp"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-1 focus:ring-secondary outline-none transition-all"
                      placeholder="john@example.com"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-1 focus:ring-secondary outline-none transition-all"
                      placeholder="+1 (555) 000-0000"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Message / Service Interest</label>
                  <textarea
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-secondary focus:ring-1 focus:ring-secondary outline-none transition-all"
                    placeholder="I'm interested in a financial audit..."
                  ></textarea>
                </div>

                <div className="flex items-center justify-between pt-4">
                  <p className="text-xs text-slate-500">
                    Your information is kept strictly confidential.
                  </p>
                  <button
                    type="submit"
                    className="bg-primary hover:bg-slate-800 text-white px-8 py-3 rounded-lg font-bold transition-all flex items-center gap-2"
                  >
                    Send Request <Send size={18} />
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
